import {h, Component} from 'preact';
import AssociatedUser from './associated-user';
import InfoMessage from './info-message';

export default class ListAssociatedUsers extends Component {
	render(properties) {
		if (properties.users && properties.users.length === 0) {
			if (properties.visibilityControllerStatus === 'RESULTS') {
				return <InfoMessage text="No match found" />;
			}
			return;
		}

		return (
			<div class="u-scroll-auto u-margin-top-default" tabIndex={0}>
				<table class="c-table">
					<thead>
						<tr>
							<th class="c-table__header">Name</th>
							<th class="c-table__header">Email</th>
							<th class="c-table__header u-whitespace-nowrap">End date</th>
							<th class="c-table__header">Remove association</th>
						</tr>
					</thead>
					<tbody>
						{properties.users.map(user => <AssociatedUser {...user} key={user.id} />)}
					</tbody>
				</table>
			</div>
		);
	}
}
